import { create } from "zustand";

export type ActiveReservation = {
  date: Date;
  boatId: number;
};

type CalendarStore = {
  selectedMonth: number;
  setSelectedMonth: (month: number) => void;
};

export const ALLOWED_MONTHS = [3, 4, 5, 6, 7, 8, 9];

const currentMonth = new Date().getMonth();

const useCalendarStore = create<CalendarStore>((set) => ({
  selectedMonth:
    ALLOWED_MONTHS.indexOf(currentMonth) > 0 ? currentMonth : ALLOWED_MONTHS[0],
  setSelectedMonth: (month) => set({ selectedMonth: month }),
}));

export default useCalendarStore;
